
// 合并
const modulesFiles = require.context('./modules', true, /\.js$/)
// 对象接收modules下所有
const currentObj = {}
const modulesObj = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath)
  return Object.assign(currentObj, Object.values(value)[0])
}, {})

export default modulesObj
